import { tgxApi } from "../../../app/tgxApi";
import { getAuthorizationHeader, getFileDownloadHeaders, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/utils/RtkQueryUtils";
import { downloadFile } from "../../../helpers/utils/FileUtils";
import { getFileName, serialize, showToast } from "../../../helpers/utils/Utils";

export const partnerPricingApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchPartnerPricing: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/partner-pricing?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['partnerPricing'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getPartnerPricingById: build.query({
            query: (regionId) => {
                return {
                    url: `/partner-pricings/${regionId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createPartnerPricing: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create-partner-pricing`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['partnerPricing'],
            async onQueryStarted(requestBody, { queryFulfilled }) {
                const action = requestBody?.id ? "Updated" : "Created";
                await handleQueryErrorAndSuccess(queryFulfilled, action, "Partner Pricing");
            },
        }),


        updatePartnerPricing: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/partner-pricings/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['partnerPricing', 'partnerPricingById', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Partner Pricing");
            },
        }),

        deletePartnerPricingById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-by-partner-pricing-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['partnerPricing'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Partner Pricing");
            },
        }),

        exportPartnerPricingData: build.query({
            query: (query) => {
                return {
                    url: `/export/partnerPricing`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => Promise<Blob> }) => {
                        const blob = await response.blob();
                        if (blob.size > 0) {
                            downloadFile(blob, getFileName("PartnerPricing"));
                            return { success: true };
                        } else {
                            showToast("No data found.");
                            return { success: false, message: "No data found." };
                        }
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),
    })
})

export const {
    useLazySearchPartnerPricingQuery,
    useCreatePartnerPricingMutation,
    useDeletePartnerPricingByIdMutation,
    useLazyExportPartnerPricingDataQuery
} = partnerPricingApi